<style>
   .container.fill-height {
        align-items: baseline !important;
    } 
</style>
<template>
    <v-btn color="primary" @click="notificacion">Enviar Notificacion</v-btn>
</template>
<script>
import axios from 'axios'
import Vue from 'vue';
export default {
    data(){
        return{

        }
    },
    methods:{
        notificacion(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};[];
            let model=this;
            axios.put('api/Actividades/ReportedeActividadUs',{
            },configuracion).then(function(response){
                  console.log('enviado')
            }).catch(function(error){
                console.log('error')
            });
        }
    }
}
</script>